import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class PortlandLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Portland, OR" />
        <LocationMicroNav />

        <LocationContent 
          category="PlacesForBikes" 
          title="Play in the Dirt"
          story="We attended opening day for Gateway Green, the new 25-acre mountain and dirt biking park opened by the City of Portland on previously vacant land. It's the first real mountain biking facility within city limits. Thanks to Portland's participation in the Big Jump, in two years the park will be accessible via a continuous low-stress biking network that will run through the city's most culturally and economically diverse neighborhoods."
        />  
        <Img
          title="Portland"
          alt="Gateway Green project image"
          sizes= { this.props.data.portlandImage.sizes }
        />   

        <LocationRelated 
          prevLocationName="Columbus, OH"
          prevLocationPath="columbus"
          prevLocationImgPath= { this.props.data.portlandPrevImage }
          nextLocationName="Texas"
          nextLocationPath="texas"
          nextLocationImgPath= { this.props.data.portlandNextImage }
        /> 
      </div>
    )
  }
}

export default PortlandLocation

// GraphQL query
export const porlandImageQuery = graphql`
  query portlandImageQuery {
    portlandImage: imageSharp(id: { regex: "/PFB_PortlandOR/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    portlandPrevImage: imageSharp(id: { regex: "/PFB_COLUMBUS/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    portlandNextImage: imageSharp(id: { regex: "/PFB_TEXAS/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/portland.js